import Head from 'next/head';
import FormValidation from '@/components/FormValidation';

const Page = () => {
  return (
    <>
      <Head>
        <title>Form-Validierung</title>
      </Head>
      <FormValidation />
    </>
  );
};

export default Page;
